<!-- Дивка с этим классом соотвествует :host {} -->
<!-- <div class="dx-error-report"> -->
<div class="dx-error-report__title">Error: {{errorTitle}}</div>
<div class="dx-error-report__message">{{errorMessage}}</div>

<!-- Возврат обратно на ту или иную страницу системы -->
<div class="dx-error-report__back_to_app_block">
  <a class="dx-error-report__btn  dx-error-report__btn--c1"
     *ngIf="showGoBackBtn"
     (click)="onGoBackToApp()">
    Вернуться в систему
  </a>
</div>

<!-- Секция с деталями ошибки (Место под стэктрэйс) -->
<div class="dx-error-report__details">
  <div class="dx-error-report__details_container"
       [ngClass]="{'dx-error-report__details_container--open': isErrorDetailsExpanded}">
    <div class="dx-error-report__details_head" (click)="onToggleErrorDetails()">
      Отчет об ошибках
    </div>
    <div class="dx-error-report__details_body">
      <div class="dx-error-report__details_content">{{errorDetails}}</div>
    </div>

    <div class="dx-error-report__details_footer">
      <button class="dx-error-report__submit_block  dx-error-report__btn"
              *ngIf="showSubmitErrorReportBtn"
              (click)="onSubmitErrorReport()">
        Отправить отчет в техподдерждку
      </button>
    </div>
  </div>
  <!-- Конец секции с деталями ошибки -->
</div>
<!-- </div> -->
